import {OrderVisit} from "v2/api/Records";

export const apiOrderVisit = (visit) => {
  return new OrderVisit({...visit});
};

export default {
  apiOrderVisit,
};




/** WEBPACK FOOTER **
 ** ./src/app/v2/api/OrderVisits.js
 **/